/* ============================================================
   Pack2Play — Anime/Shonen theme interactions
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  (function progressBar() {
    var bar = document.getElementById('p2p-progress');
    if (!bar) return;
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var pct = max > 0 ? (h.scrollTop / max) * 100 : 0;
      bar.style.width = pct + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  })();

  (function stickyShadow() {
    var scrolled = false;
    function onScroll() {
      var next = window.scrollY > 40;
      if (next !== scrolled) {
        scrolled = next;
        document.body.classList.toggle('p2p-scrolled', scrolled);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  (function reveal() {
    var els = document.querySelectorAll('.p2p-reveal, .p2p-reveal-l, .p2p-reveal-r, .p2p-reveal-pop');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var parent = entry.target.parentNode;
        var idx = parent ? Array.prototype.indexOf.call(parent.children, entry.target) : 0;
        entry.target.style.transitionDelay = ((idx % 4) * 0.08) + 's';
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  })();

  (function cardTilt() {
    if (reduced) return;
    var cards = document.querySelectorAll('.p2p-tilt');
    Array.prototype.forEach.call(cards, function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--p2p-tilt-x', (x * 8) + 'deg');
        card.style.setProperty('--p2p-tilt-y', (-y * 8) + 'deg');
      });
      card.addEventListener('mouseleave', function () {
        card.style.removeProperty('--p2p-tilt-x');
        card.style.removeProperty('--p2p-tilt-y');
      });
    });
  })();

  (function spotlight() {
    if (reduced) return;
    var tiles = document.querySelectorAll('.p2p-spotlight');
    Array.prototype.forEach.call(tiles, function (tile) {
      tile.addEventListener('mousemove', function (e) {
        var r = tile.getBoundingClientRect();
        tile.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        tile.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  })();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.p2p-add-pop');
    if (!btn) return;
    if (btn.dataset.p2pPopping === '1') return;
    btn.dataset.p2pPopping = '1';
    btn.classList.add('is-popped');
    window.setTimeout(function () {
      btn.classList.remove('is-popped');
      delete btn.dataset.p2pPopping;
    }, 1200);
  });

})();
